<template>
  <v-select
    label="Reporting Increments"
    :items="items"
    item-text="text"
    item-value="value"
    v-model="selected"
    @change="updatePeriod"
  ></v-select>
</template>

<script>
export default {
  name: "PeriodSelector",
  data() {
    return {
      selected: this.$store.state.Dashboard.widgetConfig.periodType,
      items: [
        {
          text: 'Monthly',
          value: 'month'
        },
        {
          text: 'Quarterly',
          value: 'quarter'
        },
        {
          text: 'Bi-yearly',
          value: 'bi_annual'
        },
        {
          text: 'Yearly',
          value: 'annual'
        },
      ]
    }
  },
  methods: {
    updatePeriod(selection) {
      this.$store.commit('setPeriodType',selection );
      this.$emit('period-changed', selection);
    }
  }
}
</script>

<style scoped>

</style>
